import React from 'react';

import { tv } from '../../tv';
import { Spinner } from '../spinner';
import { Text } from '../text';

/**
 * A region waiting for content it has no shape for yet, EmptyState's
 * counterpart: the accent ring centred in the region, an optional line under
 * it. The container gives the ring the brand, since Spinner turns in
 * currentColor (loading.md).
 */
const loadingStateStyles = tv({
  slots: {
    root: 'ck:flex ck:flex-col ck:items-center ck:justify-center ck:gap-3 ck:py-12 ck:text-accent-9',
  },
  variants: {
    /* Stack's isFilled contract. */
    filled: {
      true: { root: 'ck:size-full' },
      false: {},
    },
  },
  defaultVariants: { filled: false },
});

export interface LoadingStateProps {
  /** What is on its way, shown under the ring and given to assistive technology: "Loading policies". */
  label?: string;
  /** Fill the parent's allocation, and centre in it. */
  isFilled?: boolean;
  id?: string;
}

export const LoadingState = React.forwardRef<HTMLDivElement, LoadingStateProps>(
  function LoadingState({ label, isFilled = false, id }, ref) {
    const { root } = loadingStateStyles({ filled: isFilled });
    return (
      <div ref={ref} id={id} className={root()} data-component="loading-state">
        <Spinner size="lg" label={label ?? 'Loading'} />
        {label ? (
          /* The ring already carries the label; the visible line is not read twice. */
          <Text size="sm" color="muted" align="center" aria-hidden>
            {label}
          </Text>
        ) : null}
      </div>
    );
  },
);
